<ng-container *ngFor="let item of data">
    <div *ngIf="!processLoading" (click)="action(item._id)" class="webhook-card">
        <div class="name-section">
          <span class="name">{{item.name}}</span>
          <span class="type">{{item.type}}</span>
        </div>
        <div class="middle">
          <span *ngIf="item.resend == true" class="title">Duration: <span class="data">{{item.resendDuration}} seconds</span></span>
        <span *ngIf="item.acceptableError.length > 1" class="title">Errors: <span class="data">{{item.acceptableError}}</span></span>
        </div>
        <div class="end">
          <img src="../../../assets/icons/chevron-right1.svg" alt="">
        </div>
      </div>
</ng-container>
<div *ngIf="processLoading">
    <ngx-skeleton-loader></ngx-skeleton-loader>
    <ngx-skeleton-loader></ngx-skeleton-loader>
    <ngx-skeleton-loader></ngx-skeleton-loader>
</div>
<div *ngIf="data.length == 0" class="empty-state">
  <span class="empty-header">No Data Found</span>
  <span class="empty-body">You don't have any webhooks created</span>
</div>

